/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { MarkerCreationResult, MarkerInfo, MarkersCreateParameters } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class MarkersClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Markers
   * @summary Получение маркеров на скважине
   * @request GET:/geology/markers/for_well/{wellId}
   * @secure
   */
  markersGetMarkersForWell = (wellId: string, params: RequestParams = {}) =>
    this.http.request<MarkerInfo[], any>({
      path: `/geology/markers/for_well/${wellId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Markers
   * @summary Получение уникальных имён маркеров для заданного месторождения
   * @request GET:/geology/markers/for_field/{fieldId}/marker_names
   * @secure
   */
  markersGetMarkerNamesForField = (fieldId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/markers/for_field/${fieldId}/marker_names`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Markers
   * @summary Получение маркеров для заданного месторождения по имени маркера
   * @request GET:/geology/markers/for_field/{fieldId}/by_marker_name/{markerName}
   * @secure
   */
  markersGetMarkersForFieldByMarkerName = (
    fieldId: string,
    markerName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<MarkerInfo[], any>({
      path: `/geology/markers/for_field/${fieldId}/by_marker_name/${markerName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Markers
   * @summary Создание маркеров (из ГеоБД)
   * @request POST:/geology/markers
   * @secure
   */
  markersCreate = (data: MarkersCreateParameters, params: RequestParams = {}) =>
    this.http.request<MarkerCreationResult[], any>({
      path: `/geology/markers`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
